import { render, staticRenderFns } from "./sidebar_reference_widget.vue?vue&type=template&id=4906c7c8"
import script from "./sidebar_reference_widget.vue?vue&type=script&lang=js"
export * from "./sidebar_reference_widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports